import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import { c } from '@debbie/cortex/dist/index.js';
import * as updatesLib from '@debbie/cortex/dist/api/updates.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectRole } from '@debbie/cortex/dist/me/selectors.js';
import { selectUpdateTypesMap } from '@debbie/cortex/dist/update-types/selectors.js';
import THEME from '../theme.js';
import { getActivePauses } from './CasePauseStatus/index.js';
import Activity from './Icons/Activity.js';
import ArrowLeft from './Icons/ArrowLeft.js';
import ArrowRight from './Icons/ArrowRight.js';
import { Button, ButtonGroup } from './index.js';
import { Shortcut } from './/index.js';
const CaseQueue = () => {
    const history = useHistory();
    const params = useParams();
    const ids = params.ids?.split(',');
    const id = ids && ids[0];
    const singleCase = useSelector((s) => id ? selectCaseById(s, id) : null);
    const lang = useSelector((s) => s.lang);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const meRole = useSelector(selectRole);
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const activePauseUpdates = meRole && getActivePauses(caseUpdates || [], updateTypesMap || [], meRole);
    const canContinueCase = activePauseUpdates?.every((aPU) => aPU.canContinueCase) &&
        activePauseUpdates.length > 0;
    const [commandButtonPressed, setCommandButtonPressed] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        document.addEventListener('keydown', onDown);
        document.addEventListener('keyup', onUp);
        window.addEventListener('blur', onBlur);
        return () => {
            document.removeEventListener('keydown', onDown);
            document.removeEventListener('keyup', onUp);
            window.removeEventListener('blur', onBlur);
        };
    }, []);
    const onDown = (event) => {
        if (event && [17, 91].includes(event.keyCode))
            setCommandButtonPressed(true);
    };
    const onUp = (event) => {
        if ([17, 91].includes(event.keyCode))
            setCommandButtonPressed(false);
    };
    const onBlur = () => setCommandButtonPressed(false);
    const forth = () => {
        const replacement = ids?.slice(1, ids.length).join(',');
        const url = history.location.pathname.replace(params.ids, replacement);
        history.push(url);
    };
    const back = () => {
        history.goBack();
    };
    const continueCase = async () => {
        setLoading(true);
        if (commandButtonPressed &&
            canContinueCase &&
            singleCase &&
            activePauseUpdates) {
            await Promise.all(activePauseUpdates.map((u) => updatesLib.patch(u.update.updateId)));
            await c.cases.getUpdates(singleCase.caseId);
        }
        forth();
        setLoading(false);
    };
    if (ids && ids.length < 2)
        return null;
    return (React.createElement(CaseQueueStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": canContinueCase ? lang.cases.pressCommandOrCtrlToContinue : '' },
        lang.cases.casesLeft,
        " ",
        ids && React.createElement("strong", null, ids.length - 1),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(Shortcut, { keys: ['command', 'right'], onPress: (e) => {
                e.preventDefault();
                continueCase();
            }, style: {
                left: '19px',
                top: '6px',
            }, key: `forth-${params.ids}` }),
        React.createElement(Shortcut, { keys: ['command', 'left'], onPress: (e) => {
                e.preventDefault();
                back();
            }, style: {
                left: '-109px',
                top: '6px',
            }, key: `back-${params.ids}` }),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { theme: "secondary", size: "small", onClick: () => {
                    back();
                } },
                React.createElement(ArrowLeft, { style: {
                        verticalAlign: 'middle',
                    } })),
            React.createElement(Button, { size: "small", loading: loading, className: "ui-test-46774c15", onClick: continueCase },
                ids && React.createElement(React.Fragment, null,
                    "#",
                    ids[1],
                    " "),
                commandButtonPressed && canContinueCase && (React.createElement(Activity, { style: {
                        verticalAlign: 'middle',
                    } })),
                React.createElement(ArrowRight, { style: {
                        verticalAlign: 'middle',
                    } })))));
};
export default CaseQueue;
const CaseQueueStyled = styled.div `
  position: fixed;
  border-radius: 2px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);
  bottom: 125px;
  right: 0px;
  background-color: ${THEME.COLOR_SECONDARY};
  padding: ${THEME.GRID_SPACING}px;
  z-index: 1;
`;
//# sourceMappingURL=CaseQueue.js.map